<template>
  <div id="loader">
    <span class="loader"></span>
  </div>
</template>

<script>
export default {
  name: 'loader-component'
}
</script>

<style scoped>
#loader { position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; z-index: 100; align-items: center; justify-content: center; background-color: black; opacity: 0.5 }
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(153, 30, 102, 1);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  animation: pulse 1s linear infinite;
}
.loader:after {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border: 5px solid rgba(255, 207, 84, 1);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: scaleUp 1s linear infinite;
}

@keyframes scaleUp {
  0% { transform: translate(-50%, -50%) scale(0) }
  60% , 100% { transform: translate(-50%, -50%)  scale(1)}
}
@keyframes pulse {
  0% , 60% , 100%{ transform:  scale(1) }
  80% { transform:  scale(1.2)}
}
</style>
